import React from 'react';
import ReactPlayer from 'react-player';
import './VideoPlayer.scss';

const VideoPlayer = ({ src, thumbnail, height = '100%', id = null, autoPlay = true }) => {
  return (
    <div className="player-wrapper" id={id}>
      <ReactPlayer
        className="react-player"
        url={src}
        light={thumbnail}
        width="100%"
        height={height}
        controls
        playing={autoPlay}
      />
    </div>
  );
};

export default VideoPlayer;
